export const PARTNER_USER_SIGNUP_GETTING_STARTED_TEXT = "getting_started";
export const PARTNER_USER_SIGNUP_BASIC_INFORMATION_TEXT = "basic_information";
export const PARTNER_USER_SIGNUP_REQUEST_RECEIVED_TEXT = "request_received";
export const PARTNER_USER_SIGNUP_GETTING_STARTED = 1;
export const PARTNER_USER_SIGNUP_BASIC_INFORMATION = 2;
export const PARTNER_USER_SIGNUP_REQUEST_RECEIVED = 3;
